<template>
  <div class="loading-container mt-5 mx-2">
    <div class="p-2 loading-inner-container">
      <p>{{$t('LoadingRender.desc_p1')}} {{ time }} {{$t('LoadingRender.desc_p2')}}</p>
      <div class="loader mt-5"></div>
    </div>
  </div>
</template>

<script>
  /** Used to show if something is loading. Basic circle with spinning pizza */
  export default {
    name: 'LoadingRender',
    props: {
      time: {
        type: Number,
        required: false,
        default: 20
      }
    }
  }
</script>

<style scoped>
  .loading-container {
    display: flex;
    justify-content: center;
  }

  .loading-inner-container {
    display: flex;
    background-color: rgb(237, 237, 237);
    border-radius: 5px;
    text-align: center;
    align-items: center;
    flex-flow: column;
    width: 70%;
  }
  .loader {
    align-content: center;
    border: 16px solid #999999; /* Light grey */
    border-top: 16px solid #f7941e;
    border-radius: 50%;
    align-content: center;
    width: 10px;
    height: 10px;
    animation: spin 1s ease-in-out infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
